import axios from 'axios'

const API_PATH = `${process.env.REACT_APP_ENV === 'local' ? '' : '/tsp'}/manage/member`;
const API_PATH_V2 = `${process.env.REACT_APP_ENV === 'local' ? '' : '/v2'}/manage/member`;

// 會員管理 -> 會員列表
const getMembers = async (resource) => 
  await axios.get(`${API_PATH}`, { params: resource })
const postMemberExport = async (resource) =>
  await axios.post(`${API_PATH}/report`, resource, { responseType: 'blob' })

// 會員管理 -> 修改會員資料
const getAccountMember = async (resource) =>
  await axios.get(`${API_PATH}/account`, { params: resource })

const updateAccountMember = async (resource) =>
  await axios.put(`${API_PATH}/account`, resource)

// 會員管理 -> 會員車輛關聯
const getDeleteMember = async (resource) => 
  await axios.get(`${API_PATH_V2}/relation`, { params: resource })

const deleteRelationMember = async (resource) =>
  await axios.delete(`${API_PATH_V2}/relation`, { data: resource })

// 會員管理 -> 修改油車銷顧
const getCarServiceRelation = async (resource) =>
  await axios.get(`${API_PATH}/carServiceRelation`, { params: resource })

const createCarServiceRelation = async (resource) =>
  await axios.post(`${API_PATH}/carServiceRelation`, resource)

const updateCarServiceRelation = async (resource) =>
  await axios.put(`${API_PATH}/carServiceRelation`, resource)

const deleteCarServiceRelation = async (resource) =>
  await axios.delete(`${API_PATH}/carServiceRelation`, { data: resource })

// 會員管理 -> 查詢綁卡記錄
const getCardBindingQuery = async (resource) =>
  await axios.get(`${API_PATH_V2}/cardBind`, { params: resource })

// 會員管理 -> 隨插即充狀態查詢
const getPlugAndChargeStatus = async (resource) =>
    await axios.get(`${API_PATH}/plugAndChargeStatus`, { params: resource })

// 會員管理 -> 電子發票設定歷程
const getInvoiceSetting = async (resource) =>
  await axios.get(`${API_PATH}/invoiceSetting`, { params: resource })

// 會員管理 -> 會員查詢
const getManageMember = async (resource) =>
  await axios.get(`${API_PATH_V2}`, { params: resource })

const getMemberProfile = async (ikeyUid) =>
  await axios.get(`${API_PATH_V2}/${ikeyUid}/profile`)

const getMemberProfileHistory = async (resource) =>
  await axios.get(`${API_PATH_V2}/${resource.ikeyUid}/profile/history`, { params: resource })

const getMemberSSO = async (ikeyUid) =>
  await axios.get(`${API_PATH_V2}/${ikeyUid}/sso`)

const getMemberInvoice = async (ikeyUid) =>
  await axios.get(`${API_PATH_V2}/${ikeyUid}/invoice/setting`)

const getMemberInvoiceHistory = async (resource) =>
  await axios.get(`${API_PATH_V2}/${resource.ikeyUid}/invoice/setting/history`, { params: resource })

const getMemberCards = async (ikeyUid) =>
  await axios.get(`${API_PATH_V2}/${ikeyUid}/cards`)

const getMemberCardsHistory = async (resource) =>
  await axios.get(`${API_PATH_V2}/${resource.ikeyUid}/cards/history`, { params: resource })

const getMemberCardsRecordHistory = async ({ id, ...params }) =>
  await axios.get(`${API_PATH_V2}/cardBind/${id}/history`, { params })

const getMemberCharging = async (ikeyUid, resource) =>
  await axios.get(`${API_PATH_V2}/${ikeyUid}/charging`, { params: resource })

const getMemberNotification = async (ikeyUid, resource) =>
  await axios.get(`${API_PATH_V2}/${ikeyUid}/notification`, { params: resource })

const getMemberBatteryMission = async (ikeyUid, resource) =>
  await axios.get(`${API_PATH_V2}/${ikeyUid}/batteryMission`, { params: resource })

const getMemberVehicle = async (ikeyUid) =>
  await axios.get(`${API_PATH_V2}/${ikeyUid}/vehicle`)

const getMemberInformation = async (carNo) =>
  await axios.get(`${API_PATH_V2}/${carNo}/information`)

const getMemberCPO = async (evccid, resource) =>
  await axios.get(`${API_PATH_V2}/${evccid}/cpo/history`, { params: resource })

const getMemberVehicleConnectHistory = async (resource) =>
  await axios.get(`${API_PATH_V2}/connect/history`, { params: resource })

const postMemberVehicleWakeup = async (resource) =>
  await axios.post(`${API_PATH_V2}/wakeup`, resource)

const putMemberVehicleServiceStatus = async (carNo, resource) =>
  await axios.put(`${API_PATH_V2}/${carNo}/service/status`, resource)

const putMemberVehicleGpsStatus = async (carNo, resource) =>
  await axios.put(`${API_PATH_V2}/${carNo}/gps?gpsStatus=${resource.gpsStatus}`, resource)

const deleteMemberVehicleRelation = async (resource) =>
  await axios.delete(`${API_PATH_V2}/${resource.memberId}/vehicle/${resource.carNo}`)

const deleteMemberVehicleKey = async (resource) =>
  await axios.delete(`${API_PATH_V2}/${resource.memberId}/key/${resource.carId}`, { data: resource })

const putMemberVehicleConsultant = async (carNo , resource) =>
  await axios.put(`${API_PATH_V2}/${carNo}/consultant` , resource)

const getMemberChargeRecord = async (memberId , uid) =>
    await axios.get(`${API_PATH_V2}/${memberId}/charging/${uid}/record`)

const getMemberVehicleLatest30SecondData = async (vinNumber) =>
    await axios.get(`${API_PATH_V2}/${vinNumber}/latest30secend`)

export {
  getMembers,
  postMemberExport,
  getAccountMember,
  updateAccountMember,
  getDeleteMember,
  deleteRelationMember,
  getCarServiceRelation,
  createCarServiceRelation,
  updateCarServiceRelation,
  deleteCarServiceRelation,
  getCardBindingQuery,
  getPlugAndChargeStatus,
  getInvoiceSetting,
  getManageMember,
  getMemberProfile,
  getMemberProfileHistory,
  getMemberSSO,
  getMemberInvoice,
  getMemberInvoiceHistory,
  getMemberCards,
  getMemberCardsHistory,
  getMemberCharging,
  getMemberNotification,
  getMemberBatteryMission,
  getMemberVehicle,
  getMemberCPO,
  postMemberVehicleWakeup,
  putMemberVehicleServiceStatus,
  putMemberVehicleGpsStatus,
  deleteMemberVehicleRelation,
  deleteMemberVehicleKey,
  getMemberVehicleConnectHistory,
  putMemberVehicleConsultant,
  getMemberInformation,
  getMemberChargeRecord,
  getMemberVehicleLatest30SecondData,
  getMemberCardsRecordHistory
}
